import React from "react";
import styles from "./SkillsItem.module.css";

const SkillsItem = ({ label, item }) => {
  return (
    <div className={styles.itemCtn}>
      <h3 className={styles.skillLabel}>{label}</h3>
      <div className={styles.itemData}>
        {item.map((i, index) => {
          return (
            <ul key={index}>
              <li className={styles.skillListItem}>{i}</li>
            </ul>
          );
        })}
      </div>
    </div>
  );
};

export default SkillsItem;
